import * as React from 'react';
import { SVGProps } from 'react';

const IconMLSPSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1h8v2h-1.5l2.083 10H19v2H5v-2h2.417L9.5 3H8V1zm1.506 11.818 1.59-7.636h1.807l1.591 7.636H9.506z"
    />
    <path d="M7 19.319a2.998 2.998 0 0 1-1.168-.189l-2.367-.887a1 1 0 0 0-.798.042L1 19.005v-2l.773-.51a3 3 0 0 1 2.395-.125l2.367.887a1 1 0 0 0 .798-.042l1.39-.695a3 3 0 0 1 2.523-.074l1.708.732a1 1 0 0 0 .908-.062l.682-.409a3 3 0 0 1 2.885-.11l1.309.654a1 1 0 0 0 .734.063L23 16v2l-2.953 1.23a3 3 0 0 1-2.204-.19L17 18.618V23h-2v-4.234l-.109.065a3 3 0 0 1-2.725.185l-1.707-.731a1 1 0 0 0-.841.024L9 18.618V23H7v-3.681z" />
  </svg>
);
export default IconMLSPSizeM;
